export const SYSTEM_ERROR = {
  UNKNOWN: 'A system error occurred. Please try again later.',
  TIMEOUT: 'The connection timed out. Please try again later.'
}
